import {qs, qsArray, isInternetExplorer, trackEvent} from './utilities/index';
import Overlay from './overlay';
import Controls from './controls';

const VALUES = {
  next: null,
  shortcut: null,
  analyticsQuestion: null,
  analyticsAnswer: null,
  weightAmount: null,
  weightIds: null,
  color: null,
  scores: {
    v1: 0,
    v1x: 0,
    avx: 0,
    v1xld: 0,
    'tour-soft': 0,
    velocity: 0,
    trufeel: 0
  }
}

const EASE_IN_DURATION = 0.5;
const EASE_IN_STAGGER = "-=0.35";
const EASE_OUT_DURATION = 0.25;

let Question = function (params) {
  // console.log('Question Initalizing', params);

  // question vars
  let question = this;
  let questionEl = params.el;
  let inputType = questionEl.getAttribute('data-input');
  let textEl = qs('.question-text', questionEl);
  let answersEl = qs('.question-answers', questionEl);
  let answerButtonArray = qsArray('.question-answers button', questionEl);
  let dropdownsEl = qs('.question-dropdowns', questionEl);
  let dropdownA = null;
  let dropdownB = null;
  let dropdownBArray = null;
  let sliderEl = qs('.question-slider', questionEl);
  let sliderInput = null;
  let sliderValues = null;
  let sliderValueDisplay = null;
  let sliderImages = null;
  let sliderIndex = null;
  let importantBtn = null;
  let controls = new Controls();
  let timeline = null;
  question.id = params.id;

  question.trackingObj = {
    action: inputType,
    label: question.id,
    value: null
  };

  let animElArray = [questionEl, textEl];
  if (dropdownsEl) {
    animElArray.push(dropdownsEl);
  }
  answerButtonArray.forEach(function(answerEl) {
    animElArray.push(answerEl);
  });
  if (sliderEl) {
    animElArray.push(sliderEl);
  }
  animElArray.push(controls.el);

  // question values
  let values = JSON.parse(JSON.stringify(VALUES));
  values.analyticsQuestion = questionEl.getAttribute('data-analytics-question');
  question.values = values;

  // question private methods
  function initializeBrandDropDowns () {
    dropdownA = qs('#brand-select', questionEl);
    dropdownA.parentNode.classList.add('is-active');
    dropdownA.parentNode.classList.add('is-visible');
    dropdownB = null;
    dropdownBArray = qsArray('.brand-type-select', questionEl);

    dropdownA.addEventListener('change', function() {
      // console.log(dropdownA.value);
      let value = dropdownA.value;
      if (dropdownB) {
        controls.disableNextButton();
        dropdownB.value = 'default'
        dropdownB.parentNode.classList.remove('is-active');
        dropdownB.parentNode.classList.remove('is-visible');
      }
      dropdownB = qs('#' + value + '-Select');
      dropdownB.parentNode.classList.add('is-active');
      dropdownB.parentNode.clientHeight;
      dropdownB.parentNode.classList.add('is-visible');
    });

    dropdownBArray.forEach(function(el){
      el.addEventListener('change', function() {
        let optionEl = qs('[value="' + el.value + '"]', el);
        values.next = optionEl.getAttribute('data-next');
        values.shortcut = optionEl.getAttribute('data-shortcut');
        values.shortcut = values.shortcut === "" ? null : values.shortcut;
        // console.table(question.values);
        // console.log(question.id, dropdownA.value + ' ' + dropdownB.value);
        question.trackingObj.value = dropdownA.value + ' ' + dropdownB.value;
        controls.enableNextButton();

        let anyText = document.getElementById('any-model-text');
        if (anyText && el.value == anyText.value) {
          let overlay = new Overlay();
          overlay.openAnyBallWindow();
        }

      });
    });
  }

  function clearBrandDropDowns() {
    dropdownA.value = 'default';
    if (dropdownB) {
      dropdownB.value = 'default'
      dropdownB.parentNode.classList.remove('is-active');
      dropdownB.parentNode.classList.remove('is-visible');
      dropdownB = null;
    }
  }

  function initializeButtons () {
    // answerButtonArray = qsArray('.question-answers button', questionEl);
    answerButtonArray.forEach(function(b){
      b.addEventListener('click', onButtonClick);
    });
  }

  function clearSelectedButton() {
    answerButtonArray.forEach(function(b){
      b.classList.remove('selected');
    });
  }

  function onButtonClick (e) {
    clearSelectedButton();
    let button = e.target;
    
    if (button.tagName != 'BUTTON') {
      button = e.target.parentElement;
    }

    button.classList.add('selected');
    values.next = button.getAttribute('data-next');
    values.analyticsAnswer = button.getAttribute('data-analytics-answer');
    values.weightAmount = button.getAttribute('data-weight-amount');
    values.weightIds = button.getAttribute('data-weight-ids');
    values.color = button.getAttribute('data-color');
    values.scores.v1 = parseFloat(button.getAttribute('data-v1')) || 0;
    values.scores.v1x = parseFloat(button.getAttribute('data-v1x')) || 0;
    values.scores.avx = parseFloat(button.getAttribute('data-avx')) || 0;
    values.scores.v1xld = parseFloat(button.getAttribute('data-v1xld')) || 0;
    values.scores['tour-soft'] = parseFloat(button.getAttribute('data-tour-soft')) || 0;
    values.scores.velocity = parseFloat(button.getAttribute('data-velocity')) || 0;
    values.scores.trufeel = parseFloat(button.getAttribute('data-trufeel')) || 0;
    // console.log(button);
    // console.table(question.values);
    question.trackingObj.value = values.analyticsAnswer;
    controls.enableNextButton();
  }

  function initializeSlider() {
    // sliderEl = qs('.question-slider', questionEl);
    sliderInput = qs('input[type="range"]', sliderEl);
    sliderValues = qsArray('input[type="hidden"]', sliderEl);
    sliderValueDisplay = qs('.value', sliderEl);
    sliderImages = qsArray('.question-slider-images div[class^="slider-image"]', questionEl);

    if (isInternetExplorer()) {
      sliderInput.addEventListener('change', updateSlider);
    } else {
      sliderInput.addEventListener('input', updateSlider);
    }

    // console.log('Initialize Slider', sliderImages);
  }

  function updateSlider() {

    if (sliderIndex !== null && sliderImages.length) {
      sliderImages[sliderIndex].classList.remove('is-visible');
    }

    sliderValueDisplay.innerText = sliderInput.value;
    sliderIndex = parseInt(sliderInput.value);
    let selected = sliderValues[sliderIndex];

    values.next = selected.getAttribute('data-next');
    values.analyticsAnswer = selected.getAttribute('data-analytics-answer');
    values.weightAmount = selected.getAttribute('data-weight-amount');
    values.weightIds = selected.getAttribute('data-weight-ids');
    values.color = selected.getAttribute('data-color');
    values.scores.v1 = parseFloat(selected.getAttribute('data-v1')) || 0;
    values.scores.v1x = parseFloat(selected.getAttribute('data-v1x')) || 0;
    values.scores.avx = parseFloat(selected.getAttribute('data-avx')) || 0;
    values.scores.v1xld = parseFloat(selected.getAttribute('data-v1xld')) || 0;
    values.scores['tour-soft'] = parseFloat(selected.getAttribute('data-tour-soft')) || 0;
    values.scores.velocity = parseFloat(selected.getAttribute('data-velocity')) || 0;
    values.scores.trufeel = parseFloat(selected.getAttribute('data-trufeel')) || 0;

    if (sliderImages.length) {
      sliderImages[sliderIndex].classList.add('is-visible');
    }

    // console.log('Slider Changed', values);
    question.trackingObj.value = values.analyticsAnswer;
  }

  // question public methods
  this.show = function(cb) {
    clearTimeline();
    if (inputType === 'slider') {
      updateSlider();
    }
    TweenLite.set(animElArray, { opacity: 0 });
    questionEl.classList.add('is-active');
    timeline = new TimelineLite({
      onComplete: function() {
        if (cb) {
          cb();
        }
      }});
    animElArray.forEach(function (el, i) {
      if (i === 0) {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 });
      } else {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 }, EASE_IN_STAGGER);
      }
    });
    controls.setNextTrackingObj(question.trackingObj);
  }

  this.hide = function(cb) {
    clearTimeline();
    questionEl.classList.add('is-disabled');
    timeline = new TimelineLite({ onComplete: function() {
        questionEl.classList.remove('is-active');
        questionEl.classList.remove('is-disabled');
        if (cb) {
          cb();
        }
      }});
    timeline.to(animElArray, EASE_OUT_DURATION, { opacity: 0 });
  }

  this.getNext = function () {
    return question.values.next;
  }

  this.getShortcut = function () {
    return question.values.shortcut !== '' ? question.values.shortcut : null;
  }

  this.getInputType = function () {
    return inputType;
  }

  this.reset = function() {
    switch (inputType) {
      case 'brand-selector':
        values = JSON.parse(JSON.stringify(VALUES));
        values.analyticsQuestion = questionEl.getAttribute('data-analytics-question');
        question.values = values;
        clearBrandDropDowns();
        break;
      case 'buttons':
        values = JSON.parse(JSON.stringify(VALUES));
        values.analyticsQuestion = questionEl.getAttribute('data-analytics-question');
        question.values = values;
        clearSelectedButton();
        break;
      case 'slider':
        sliderInput.value = '1';
        break;
    }
  }

  // call question specific initializers
  switch (inputType) {
    case 'brand-selector':
      initializeBrandDropDowns();
      break;
    case 'buttons':
      initializeButtons();
      break;
    case 'slider':
      initializeSlider();
      break;
  }

  // check for important button overlay
  importantBtn = qs('.btn-important', questionEl);

  if (importantBtn) {
    importantBtn.addEventListener('click', onImportantBtnClick);
  }

  function onImportantBtnClick () {
    let overlay = new Overlay();
    console.log(question.id);
    overlay.openImportantWindow(question.id);
  }

  function clearTimeline() {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

}

export default Question;
